/** @format */

export const plkTariffMapper = {
    TARIFF_INT: 'int_tariff',
    TARIFF_ABO: 'abo_tariff',
    TARIFF_MIX: 'mix_tariff',
    TARIFF_ABO_NUMBER: 43,
    TARIFF_INT_NUMBER: 45,
    TARIFF_MIX_NUMBER: 48,
    TARIFF_ABO_TRANS: 'tariffs:plk.abo_tariff',
    TARIFF_INT_TRANS: 'tariffs:plk.int_tariff',
    TARIFF_MIX_TRANS: 'tariffs:plk.mix_tariff',
    TARIFF_EMPTY: 'tariffs:plk.empty',
};

export const PlkTariffsList = [
    { id: plkTariffMapper.TARIFF_ABO, name: plkTariffMapper.TARIFF_ABO_TRANS },
    { id: plkTariffMapper.TARIFF_INT, name: plkTariffMapper.TARIFF_INT_TRANS },
    { id: plkTariffMapper.TARIFF_MIX, name: plkTariffMapper.TARIFF_MIX_TRANS },
];

export function plkTariffNameToName(tariffName) {
    switch (tariffName) {
        case plkTariffMapper.TARIFF_ABO:
            return plkTariffMapper.TARIFF_ABO_TRANS;
        case plkTariffMapper.TARIFF_INT:
            return plkTariffMapper.TARIFF_INT_TRANS;
        case plkTariffMapper.TARIFF_MIX:
            return plkTariffMapper.TARIFF_MIX_TRANS;
        default:
            return plkTariffMapper.TARIFF_EMPTY;
    }
}

export function plkTariffIntToName(tariffId) {
    switch (tariffId) {
        case plkTariffMapper.TARIFF_ABO_NUMBER:
            return plkTariffMapper.TARIFF_ABO;
        case plkTariffMapper.TARIFF_INT_NUMBER:
            return plkTariffMapper.TARIFF_INT;
        case plkTariffMapper.TARIFF_MIX_NUMBER:
            return plkTariffMapper.TARIFF_MIX;
        default:
            return '';
    }
}
